import io from 'socket.io-client';
import { getHostname } from 'utils/common';

const hostname = getHostname();

export const socket = io(`https://notification.${hostname}`, { 
    path: '/socket.io',
    autoConnect: false,
    transports: ['websocket'],
});